import { useState, useEffect } from 'react'
import PageHeader from '../../components/common/PageHeader'
import DynamicTable from '../../components/common/DynamicTable';
import CompanyFormModal from '../../components/modals/forms/CompanyFormModal';
import { listCompany, createCompany, editCompany, deleteCompany, showPassCode } from '../../api/endpoints/company';
import showSuccessAlert from '../../utils/swalAlerts/showSuccessAlert';
import showErrorAlert from '../../utils/swalAlerts/showErrorAlert';
import { showDeleteAlert } from '../../utils/swalAlerts/showDeleteAlert';
import { useNavigate } from 'react-router-dom';
//import { usePageSession } from '../context/PageSessionContext';

const List = () => {
  const [company, setCompany] = useState([]);
  const [search, setSearch] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [listData, setListData] = useState([]);
  const navigate = useNavigate();
  

  useEffect(()=>{
    async function fetchData() {
      const response  = await listCompany();
      console.log(response);
      if(response.status === 200){
        console.log(response.data.data);
        setListData(response.data.data);
      }else{
        // show alert something went wrong
      }
    }
    fetchData();  
  },[]);

  const headerColumns = [
    { header: "Company Name", accessor: "company_name"},
    { header: "Contact Person", accessor: "contact_person"},
    { header: "Email", accessor: "email_id" },
    { header: "Mobile", accessor: "comp_mobile" },
    { header: "Role", accessor: "role.name" },
    {
      header: "Status",
      accessor: "comp_status",
      render: (value) => (
        <span className={`badge ${value === 1 ? "bg-success" : "bg-danger"}`}>
          {value === 1 ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];

  const handleAdd = () => {
    setSelectedId(null);
    setModalVisible(true);
  };

  const handleEdit = (row) => {
    console.log(row);
    setSelectedId(row.comp_id);
    console.log(row.comp_id);
    setModalVisible(true);
  };

  const handlePasscode = (row) => {
    console.log(row);
    showDeleteAlert({
      title: 'Are you sure you want to view the password?',
      message: '',
      confirmButtonText: 'Yes, Show!',
      onConfirm: async () => {
        try {
          const response = await showPassCode(row.comp_id);
          console.log(response);
          if(response.status === 200){
            // send sucess 
            console.log(response.data);
            if(response.data.success){
              showSuccessAlert({
                title: "Password",
                message: atob(response.data.message),
                icon: "success",
                onBack: () => window.location.reload(),
              })
            }else{
              showErrorAlert({
                title: "Oops...! Something went Wrong !",
                message: "Please try after sometime.",
                icon: "error",
              })
            }
            
          }
          // Optionally refresh data or show success alert
        } catch (error) {
          console.error('Delete failed:', error);
          // Optionally show error alert
          showErrorAlert({
            title: "Oops...! Something went Wrong !",
            message: error.message,
            icon: "error",
          })
        }
      }
    });
  }

  const handleDelete = (row) => {
    showDeleteAlert({
      title: 'Are you sure you want to delete this Company?',
      message: 'This action is irreversible.',
      confirmButtonText: 'Yes, delete it!',
      onConfirm: async () => {
        try {
          const response = await deleteCompany(row.comp_id);
          console.log(response);
          if(response.status === 200){
            // send sucess 
            console.log(response.data);
            if(response.data.success){

              showSuccessAlert({
                title: "Successful!",
                message: response.data.message,
                icon: "success",
                onBack: () => window.location.reload(),
              })
            }else{
              showErrorAlert({
                title: "Oops...! Something went Wrong !",
                message: "Please try after sometime.",
                icon: "error",
              })
            }
            
          }
          // Optionally refresh data or show success alert
        } catch (error) {
          console.error('Delete failed:', error);
          // Optionally show error alert
          showErrorAlert({
            title: "Oops...! Something went Wrong !",
            message: error.message,
            icon: "error",
          })
        }
      }
    });
  }

  const handleSave = async (company) => {
    let response = {};
    let swalmsg = "";
    if (company.comp_id) {
      setCompany((prev) =>
        prev.map((c) => (c.comp_id === company.comp_id ? company : c))
      );
      delete company.email_id;
      response = await editCompany(company);
      swalmsg = 'The Company successfully editted.';
    } else {
      setCompany((prev) => [...prev, { ...company, comp_id: Date.now().toString() }]);
      delete company.comp_id;
      response = await createCompany(company);
      swalmsg = 'The Company successfully created.';
    }
    if(response.status === 200){
        showSuccessAlert({
          title: "Successful!",
          message: swalmsg,
          icon: "success",
          onBack: () => window.location.reload(),
        })
      }else{
        showErrorAlert({
          title: "Oops...! Something went Wrong !",
          message: "Please try after sometime.",
          icon: "error",
        })
      }
    
  };

  const handlehierarchy = (row) => {
    const link = '/'+row.comp_id+'/customer/list';
    console.log(link);
    navigate(link);
  }

  return (
    <>
    <PageHeader  title="Company List" breadcrumbs={[ {label: 'Administration'}, {label: 'Company List'}]}/>
    <DynamicTable
      data={listData}
      columns={headerColumns}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      onPassCode={handlePasscode}
      onDeleteMultiple={() => console.log("Bulk delete")}
      onHierarchy={handlehierarchy}
      //search={search}
      //onSearchChange={(e) => setSearch(e.target.value)}
    />

    <CompanyFormModal
        show={modalVisible}
        onClose={() => setModalVisible(false)}
        onSave={handleSave}
        compId={selectedId}
      />
    
    </>
  )
}

export default List